import { useEffect, useRef, useState } from 'react';

const MarqueeBox = ({ children, text, className, ...props }) => {
    const [textWidthOverflows, setTextWidthOverflows] = useState(false);
    const marqueeBoxContainerRef = useRef(null);

    const determineIfTextOverflows = () => {
        const marqueeBoxContainer = marqueeBoxContainerRef.current;
        const textContainer = marqueeBoxContainer?.firstChild;

        if (marqueeBoxContainer.clientWidth < textContainer.clientWidth) {
            setTimeout(() => {
                setTextWidthOverflows(true);
            }, 1000);
        } else {
            setTextWidthOverflows(false);
        }
    };

    // todo: add it later
    // useEffect(() => {
    //     window.addEventListener('resize', determineIfTextOverflows);
    //
    //     return () => {
    //         window.removeEventListener('resize', determineIfTextOverflows);
    //     }
    // }, [])

    useEffect(() => {
        determineIfTextOverflows();
    }, [text]);

    return (
        <div
            ref={marqueeBoxContainerRef}
            className={`${className} ${textWidthOverflows ? 'marquee-container' : ''}`}
            {...props}>
            {children}
        </div>
    );
};

export default MarqueeBox;
